
export const SCOPES = [
    { name: "read", label: "Leitura" },
    { name: "write", label: "Escrita" },
    { name: "products", label: "Produtos" },
    { name: "orders", label: "Pedidos" },
    { name: "offers", label: "Ofertas" },
    { name: "admin", label: "Acesso de Admin (Staff)" },
    { name: "user_award", label: "Premiações de Usuário" }
]
